module.exports = __webpack_public_path__ + "img/laying-classica-on.17d5bd42.svg";